import { trpc } from '@/utils/trpc';
import { useQuery } from '@tanstack/react-query';

export const useGetOrganizationFacesheets = (params?: {
  organizationProfileId?: string;
  orgWideOnly?: boolean;
  enabled?: boolean;
}) => {
  const { enabled = true, ...queryParams } = params ?? {};
  return useQuery({
    ...trpc.organizationsRouter.getOrganizationFacesheets.queryOptions(
      queryParams,
    ),
    enabled,
  });
};

export const useGetOrganizationProfileFacesheets = (
  organizationProfileId: string | undefined,
) => {
  return useQuery({
    ...trpc.organizationProfilesRouter.getOrganizationProfileFacesheets.queryOptions(
      { organizationProfileId: organizationProfileId! },
    ),
    enabled: !!organizationProfileId,
  });
};
